import React from "react";
import AccountSideBar from "./Nav/AccountSideBar";

export default function AuthLayout(props) {
  return (
    <div id="content">
      <div className="container pt-50 pb-50">
        <div className="row">
          <div className="col-lg-3">
            <AccountSideBar />
          </div>
          <div className="col-lg-9">{props?.children}</div>
        </div>
      </div>
    </div>
  );
}
